// Temporary override to disable all luxury textures for performance optimization
export const luxuryTextures = {
  // Override all noise textures to be empty
  noise: {
    light: {},
    dark: {},
  },
  
  // Override grain textures to be empty  
  grain: {
    fine: {},
    coarse: {},
  },
  
  // Keep the rest but make them empty for now
  glass: {
    light: {},
    dark: {},
    gold: {},
  },
  
  // Override all other texture functions to return empty objects
  luxurySurface: () => ({}),
  premiumCard: () => ({}),
  elevatedSurface: () => ({}),
  
  // Keep pattern, mesh, layeredGradient empty too
  pattern: {
    dots: {},
    lines: {},
    grid: {},
  },
  
  mesh: {
    golden: {},
  },
  
  layeredGradient: {
    premium: {},
    luxury: {},
    elegant: {},
  },
};

// Keep the helper function but make it return just the base styles
export const withLuxuryTexture = (baseStyles, ...textures) => baseStyles;

// Keep animation keyframes for reference but they won't be used
export const textureAnimations = `
  @keyframes grain {
    0%, 100% { transform: translate(0, 0); }
    10% { transform: translate(-5%, -10%); }
    20% { transform: translate(-15%, 5%); }
    30% { transform: translate(7%, -25%); }
    40% { transform: translate(-5%, 25%); }
    50% { transform: translate(-15%, 10%); }
    60% { transform: translate(15%, 0%); }
    70% { transform: translate(0%, 15%); }
    80% { transform: translate(-15%, 0%); }
    90% { transform: translate(10%, 5%); }
  }
`;